
var sensors_event_intercept = {}


var sensors = window["sensorsDataAnalytic201505"];
sensors.init({
  /* sdk_url: '//bloomchic.au/cdn/shop/t/20/assets/sdata.min.js?v=34880658631685481851741768511', */
  name: "sensors",
  server_url: "https://unicorn.bloomchic.com/sa?project=production",
  max_string_length: 6000,
  cross_subdomain: true,
  show_log: false,
  app_js_bridge: window.navigator.userAgent.indexOf('Bloomchic') > -1,
  heatmap: {
    clickmap: "default",
    scroll_notice_map: "default",
    collect_tags: {
      li: true,
      label: true,
      div: true,
      img: true, //  /bloomchic.com\/(blogs|pages)/.test(window.location.href) // 特定页面开启img
    }
  },
  batch_send: {
    send_interval: 3000,
  },
  use_client_time: true,
  send_type: "beacon",
  is_track_device_id: true,
  preset_properties: {
    //是否采集 $latest_utm 最近一次广告系列相关参数，默认值 true。
    latest_utm: true,
    //是否采集 $latest_traffic_source_type 最近一次流量来源类型，默认值 true。
    latest_traffic_source_type: true,
    //是否采集 $latest_search_keyword 最近一次搜索引擎关键字，默认值 true。
    latest_search_keyword: true,
    //是否采集 $latest_referrer 最近一次前向地址，默认值 true。
    latest_referrer: true,
    //是否采集 $latest_referrer_host 最近一次前向地址，1.14.8 以下版本默认是true，1.14.8 及以上版本默认是 false，需要手动设置为 true 开启。
    latest_referrer_host: true,
    //是否采集 $latest_landing_page 最近一次落地页地址，默认值 false。
    latest_landing_page: true,
    //是否采集 $url 页面地址作为公共属性，1.16.5 以下版本默认是 false，1.16.5 及以上版本默认是 true。
    url: true,
    //是否采集 $title 页面标题作为公共属性，1.16.5 以下版本默认是 false，1.16.5 及以上版本默认是 true。
    title: true
  }
});

function addContryToProductId(data) {
  function addContryCode(value) {
    return `${window.Bloom.global.site_code.toLocaleUpperCase() !== 'SPUS' ? `${window.Bloom.global.site_code}_` : ''}${value}`
  }
  function handle_product_id() {
    if (data.properties['product_id']) {
      // product_id参数处理
      data.properties['product_id'] = addContryCode(data.properties['product_id']);
    }
  }
  handle_product_id()

  function handle_product_id_list() {
    if (data.properties['product_id_list']) {
      // product_id_list处理
      let product_id_list = data.properties['product_id_list'].split(';')
      if (Object.prototype.toString.call(product_id_list) === '[object Array]') {
        product_id_list = product_id_list.map((product_id) => {
          if (product_id) {
            return addContryCode(product_id)
          }
          return product_id
        })
        data.properties['product_id_list'] = product_id_list.join(';')
      }
    }
  }
  handle_product_id_list()

  function handle_parent_product_id() {
    if (data.properties['parent_product_id']) {
      // parent_product_id处理
      data.properties['parent_product_id'] = addContryCode(data.properties['parent_product_id']);
    }
  }
  handle_parent_product_id()

  return data
}

sensors.registerPropertyPlugin({
  properties: function (data) {
    data = addContryToProductId(data)
  }
});

function handleAppBridgeProperties() {
  if (document.referrer) {
    var url = window.sessionStorage.getItem('referrer_url') || document.referrer
    // var url = 'android-app://com.bloomchic.app.hellowords-020300/'
    var url_logo = 'android-app://com.bloomchic.app.'
    if (url && url.indexOf(url_logo) > -1) {
      window.sessionStorage.setItem('referrer_url', url)
      var url_params = url.replace(/\/$/, '').replace(url_logo, '').split('-')
      var device_id = url_params[0] || ''
      var $app_version = url_params[1].replace(/\d\d/ig, s => Number(s) + '.').replace(/\.$/, '')
      // if (sensors && device_id) {
      //   sensors.identify(device_id, false);
      // } 
      return {
        $device_id: device_id,
        $app_version: $app_version,
        $app_id: 'com.bloomchic.app'
      }
    }
    return {}
  }
  return {}
}
// 判断
function getCheckoutId() {
  var path = window.location.pathname
  var url = window.location.href
  if (url.indexOf('checkouts') > -1) {
    var pathArr = path.split('/')
    if (pathArr.length == 4) {
      return pathArr[3]
    }
  }
  return ''
}

function getPlatFormType() {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var getArr = Agents.filter(function (i) {
    return userAgentInfo.includes(i)
  })
  return appBridgeResult["$device_id"] ? "Android" : (getArr.length ? "Mobile_Web" : "PC_Web")
}

/**
 * 判断是否登录
 * @returns 
 */
function checkIsLogin() {
  return !!window.global.email && window.localStorage.getItem('customer_uid')
}
/**
 * 获取uid / 可能是临时的
 * @returns 
 */
function getCustomerUid() {
  if (!!window.global.email) {
    return window.localStorage.getItem('customer_uid') || ''
  } else {
    var temporary_customer = window.localStorage.getItem('temporary_customer') // 临时
    if (temporary_customer) {
      return JSON.parse(temporary_customer).uid || ''
    }
    return ''
  }
}
/** 获取用户相关信息 */
function getCustomerInfo() {
  var customer_info = window.localStorage.getItem('temporary_customer')
  if (window.global.email) {
    customer_info = window.localStorage.getItem('reality_customer')
  }
  if (!customer_info) {
    return null
  }
  return JSON.parse(customer_info)
}


function getOsInfo() {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = 'Unknown';
  var version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows nt 5.2") > -1) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
      version = "Windows 7";
    } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows nt 10.0") > -1) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 || userAgent.indexOf("bsd") > -1) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android"
    } else {
      name = "Linux";
    }

  } else {
    name = "Unknown";
  }
  var os = new Object();
  os.name = name;
  os.version = version;
  return os;
}
/**
 * 获取url参数
 * @param name 
 * @returns 
 */
function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}
/**
 * 获取用户隐私参数
 */
function getPrivacySettings() {
  var result = {
    enable_preferences_data: Number(window.localStorage.getItem('enable_preferences_data') || 1),
    enable_analytics_data: Number(window.localStorage.getItem('enable_analytics_data') || 1),
    enable_marketing_data: Number(window.localStorage.getItem('enable_marketing_data') || 1),
    is_privacy_region: window.localStorage.getItem('is_privacy_region') || 'unknown'
  }
  if (window.Shopify?.customerPrivacy) {
    result = {
      enable_preferences_data: Number(window.Shopify?.customerPrivacy.preferencesProcessingAllowed()),
      enable_analytics_data: Number(window.Shopify?.customerPrivacy.analyticsProcessingAllowed()),
      enable_marketing_data: Number(window.Shopify?.customerPrivacy.marketingAllowed()),
      is_privacy_region: window.Shopify?.customerPrivacy.shouldShowBanner() ? 'yes' : 'no'
    }
    window.localStorage.setItem('enable_preferences_data', result.enable_preferences_data);
    window.localStorage.setItem('enable_analytics_data', result.enable_analytics_data);
    window.localStorage.setItem('enable_marketing_data', result.enable_marketing_data);
    window.localStorage.setItem('is_privacy_region', result.is_privacy_region);
  }
  return result
}
/**
 * 注册隐私监听事件与更新
 */
function initPrivacyEvents() {
  function setPrivacys() {
    var result = getPrivacySettings()
    if (result && sensors) {
      sensors.registerPage(result)
    }
  }
  window.Shopify?.loadFeatures?.(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        if (sensors) {
          // 如果localStorage中有数据，则认为用户已经初始化过了 
          const is_first = !window.localStorage.getItem('enable_preferences_data')
          sensors.track('PrivacySettingsSdkError', {
            is_first,
            error_msg: error?.message || error.msg || ''
          })
        }
        return
      }
      setPrivacys()
    },
  );
  document.addEventListener('visitorConsentCollected', () => {
    setPrivacys()
  });
}
/**
 * 转成北京时间
 * @param localDate 
 * @returns 
 */
function convertToBeijingTime(localDate) {
  // 获取用户的时区信息
  var userOffset = -new Date(localDate.toISOString()).getTimezoneOffset();
  // 计算北京时间
  var beijingOffset = 8 * 60; // 北京时间偏移量（东八区）
  var beijingTime = new Date(localDate.getTime() + (beijingOffset - userOffset) * 60 * 1000);
  return beijingTime;
}
/**
 * 获取新老客
 * @returns 
 */
function getNewOrderUser() {
  var customer_info = getCustomerInfo();
  if (customer_info && customer_info.hasOwnProperty('first_order_created_at')) {
    if (customer_info.first_order_created_at) {
      var order_time = new Date(customer_info.first_order_created_at * 1000);
      var now_time = convertToBeijingTime(new Date());
      var time_difference = Math.abs(now_time - order_time);
      var days_difference = Math.round(time_difference / (1000 * 3600 * 24));
      return {
        new_order_user: days_difference > 1 ? 0 : 1
      }
    } else {
      return {
        new_order_user: 1
      }
    }
  }
  return {}
}
/** fb_latest_ad_landing_page */
function getLatestAdLandingPage() {
  var latest_ad_landing_page = window.localStorage.getItem('latest_ad_landing_page') || '';
  var latest_ad_time = window.localStorage.getItem('latest_ad_time') || '';
  var fb_latest_ad_landing_page = window.localStorage.getItem('fb_latest_ad_landing_page') || '';
  var gg_latest_ad_landing_page = window.localStorage.getItem('gg_latest_ad_landing_page') || '';
  var url = window.location.href;
  if (url.includes('utm_source') || url.includes('fbclid') || url.includes('_gclid')) {
    if (url != latest_ad_landing_page) {
      latest_ad_landing_page = url
      latest_ad_time = parseInt(Date.now() / 1000)
    }
  }
  if (url.includes('utm_source=facebook') || url.includes('fbclid')) {
    if (url != fb_latest_ad_landing_page) {
      fb_latest_ad_landing_page = url
    }
  }
  if (url.includes('utm_source=google') || url.includes('_gclid')) {
    if (url != gg_latest_ad_landing_page) {
      gg_latest_ad_landing_page = url
    }
  }
  window.localStorage.setItem('latest_ad_landing_page', latest_ad_landing_page);
  window.localStorage.setItem('latest_ad_time', latest_ad_time);
  window.localStorage.setItem('fb_latest_ad_landing_page', fb_latest_ad_landing_page);
  window.localStorage.setItem('gg_latest_ad_landing_page', gg_latest_ad_landing_page);
  return {
    latest_ad_landing_page,
    latest_ad_time,
    fb_latest_ad_landing_page,
    gg_latest_ad_landing_page
  }
}


/** 针对页面通用数据上报 */
function registerPageData() {
  let data = {};
  try {
    var template = document.querySelector('body').getAttribute('data-template');
    console.log('tempalte===>', template)
    switch (template) {
      case 'collection':
        data = sensor_collectionPageData();
        break;
      case 'product':
        data = sensor_productPageData();
        break;

    }
  } catch (error) {
  }
  return data;
}


// app场景中更新distinct_id
var appBridgeResult = handleAppBridgeProperties();
if (sensors && appBridgeResult["$device_id"]) {
  sensors.identify(appBridgeResult["$device_id"], false);
}
var pageData = registerPageData();
var privacySettings = getPrivacySettings();
var newOrderUser = getNewOrderUser();
var latestAdLandingPage = getLatestAdLandingPage()
/** 注册事件 */
initPrivacyEvents();

/** 注册全局页面上报的通用参数 */
sensors.registerPage({
  ...pageData,
  web_platform_type: getPlatFormType(),
  web_is_login: Number($("body").data("customer")) > 0,
  is_new: Number($("body").data("customer")) < 2,
  web_language: navigator.language,
  referrer_url: document.referrer,
  uid: getCustomerUid(),
  $user_agent: navigator.userAgent,
  checkout_id: getCheckoutId(),
  page_code: sensor_f_get_pagecode(),
  current_page: sensor_f_get_pagecode(),
  page_from: sensor_f_get_pagecode(document.referrer),
  from_page: get_from_info().from_page,
  from_module: get_from_info().from_module,
  host_url: window.location.origin,
  site_code: window.Bloom.global.site_code,
  ...privacySettings,
  ...appBridgeResult,
  ...newOrderUser,
  ...latestAdLandingPage
});


if (checkIsLogin()) {
  var site_code = window.Bloom.global.site_code;
  var customer_uid = `${site_code != 'SPUS' ? `${site_code}_` : ''}` + window.localStorage.getItem('customer_uid');
  sensors.login(customer_uid);
}


/** 获取hash值 */
function getHashCode(str) {
  var hash = 0, i, chr;
  var length = str.length;
  if (length === 0) return hash;
  for (i = 0; i < length; i++) {
    chr = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash;
}


/** 处理重复上报的数据 */
sensors.trackRepeat = function (name, data) {
  try {
    var interceptList = Object.keys(sensors_event_intercept);
    var localInterceptSensorsData = JSON.parse(window.sessionStorage.getItem('local_intercept_sensors_data') || '{}');
    if (interceptList.includes(name) && sensors_event_intercept[name]) {
      var currentData = {
        ...data,
        page_code: data?.page_code || sensor_f_get_pagecode() || ''
      }
      var currentKey = name + '_' + sensors_event_intercept[name].key.reduce((a, b) => a.concat(currentData[b] != undefined ? currentData[b] : ''), []).join('_');
      var currenInterval = sensors_event_intercept[name].interval;
      currentKey = String(getHashCode(currentKey));
      var currentTime = parseInt(Date.now() / 1000);
      if (!localInterceptSensorsData[currentKey] || (localInterceptSensorsData[currentKey] && currentTime - localInterceptSensorsData[currentKey] > currenInterval)) {
        sensors.track(name, data);
        localInterceptSensorsData[currentKey] = currentTime;
      }
      window.sessionStorage.setItem('local_intercept_sensors_data', JSON.stringify(localInterceptSensorsData));
    } else {
      sensors.track(name, data);
    }
  } catch (error) {
    console.log('error===>', name, data, error)
    sensors.track(name, data);
  }
}

sensors.quick("autoTrack");

/*动态加载js*/
function loadJS(url, callback) {
  // 先注释掉，checkout 暂没有ab测
  var script = document.createElement("script"),
    fn = callback || function () { };
  script.type = "text/javascript";
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    script.onload = function () {
      fn();
    };
  }

  script.src = url;

  document.getElementsByTagName("body")[0].appendChild(script);
}

// 获取url
function getImgUrl(el) {
  var imgDOM = $(el).find('img')[0]
  var result = ''
  if (!imgDOM) {
    return result
  }
  if (imgDOM.src) {
    result = imgDOM.src.replace(/^(http(s)?)?(\:)?\/\//, 'https://')
  }
  if (!result && imgDOM.srcset) {
    result = imgDOM.srcset.split(', ').slice(-1)[0].split(' ')[0].replace(/^(http(s)?)?(\:)?\/\//, 'https://').replace(/_(\d+?)x\./, '.')
  }
  return result
}

/**
 * 新的通用获取单个商品的上报数据
 */
function sensor_f_get_product(e) {
  var parant = $(e.target).parents(".blc-product-mars") || $(e.target);
  var handle = parant.attr("data-handle") || "";
  var product_id = parant.attr("data-spu") || parant.attr("data-productid") || ""; // 这个是id
  var sku = parant.attr("data-sku") || "";
  var product_name = parant.attr("data-title") || parant.attr("data-title");
  var product_url = window.location.origin + '/products/' + handle
  var web_original_price = Number(parant.attr("data-delprice") || 0);
  var web_current_price = Number(parant.attr("data-price") || 0);
  var web_discount_price = web_original_price - web_current_price;
  var module_name = parant.attr("data-module-name") || "";
  var web_module_number = parant.attr("data-web-module-number") || "";
  var result = {
    page_code: sensor_f_get_pagecode(),
    product_spu: sku.replace(/[A-Z][a-z]+.*$/, ""),
    product_name: product_name,
    // handle: handle,
    product_url: product_url,
    is_available: true,
    web_original_price: web_original_price,
    web_current_price: web_current_price,
    web_discount_price: web_discount_price,
    module_name: module_name,
    product_id: product_id,
    web_module_number
  }
  return result;
}

/* 页面当前显示元素 */
function sensor_f_getClassTag(data, needScroll = true) {
  let t1 = 0;
  let t2 = 0;
  let timer = null;
  document.onscroll = function () {
    clearTimeout(timer);
    t1 = document.documentElement.scrollTop || document.body.scrollTop;
    timer = setTimeout(isScrollEnd, 500);
  };
  if (!needScroll) {
    isScrollEnd();
  }

  function isScrollEnd() {
    t2 = document.documentElement.scrollTop || document.body.scrollTop;
    if (!needScroll || (t2 == t1 && needScroll)) {
      //console.log('滚动结束');
      data.map((item) => {
        $(item.className).each(function (i, e) {
          //竖直方向判断
          var isT = false;
          //元素高度大于页面高度--只判断是否露出
          if ($(e).height() > window.innerHeight) {
            if (
              $(e).offset().top + 50 > t2 &&
              $(e).offset().top - 50 < t2 + window.innerHeight
            ) {
              isT = true;
            }
          }
          //元素高度小于页面高度--需完全露出
          else {
            /*
            if (
              t2 < $(e).offset().top &&
              $(e).height() + $(e).offset().top < t2 + window.innerHeight
            ) {
              isT = true;
            }
            */
            // 原来的条件比较严苛
            var a = $(e).offset().top;
            if (
              a > $(window).scrollTop() &&
              a < $(window).scrollTop() + $(window).height()
            ) {
              // console.log('~在可以视区域~')
              isT = true;
            }
          }
          if (isT) {
            if (
              $(e).offset().left >= 0 &&
              $(e).offset().left + $(e).width() <= window.innerWidth
            ) {
              item.func(e);
            }
          }
        });
      });
    }
  }
}



/* 获取页面Code，不传url，就是直接用当前url */
function sensor_f_get_pagecode(url) {
  let page_code = $("body").data("template");
  try {
    // 购物车也相当于一个页面
    if (theme.ShopCart && theme.ShopCart.drawer.isOpen) {
      return '购物车'
    }
    // 没有url，默认使用当前href
    let link = location.href
    // 传入url转page_code
    if (url) {
      const urlObj = new window.URL(url)
      if (urlObj.hostname !== location.hostname) {
        return '站外'
      }
      if (urlObj.pathname === '/') {
        return '首页'
      }
      link = urlObj.href
      // document.refer是空字符串的情况
    } else if (url === '') {
      return '直接访问'
    }
    if (link.includes("checkouts") > 0) {
      return "支付页";
    }
    if (link.includes('products')) {
      return '商详页'
    }
    if (link.includes('collections')) {
      return '商品集合页'
    }
    if (link.includes('pages/me')) {
      return '个人页'
    }
    if (link.includes('account#/orders')) {
      return '订单列表'
    }
    if (link.includes('account#/wishlist')) {
      return '收藏列表'
    }
    if (link.includes('account#/reviews')) {
      return '评论列表'
    }
    if (link.includes('account#/rewards')) {
      return '优惠券列表'
    }
    if (link.includes('account/login')) {
      return '登录'
    }
    if (link.includes('account/register')) {
      return '注册'
    }
    if (link.includes('account')) {
      return '个人页'
    }
    if (link.includes('search')) {
      return '搜索结果'
    }
    if (link.includes('pages')) {
      return 'Page页面'
    }
    if (link.includes('thank_you')) {
      return '支付结果页'
    }
    if (link.includes('orders')) {
      return '订单详情页'
    }
    if (page_code === "index") {
      return '首页'
    }
    return page_code || '其他'
  } catch (err) {
    return page_code || '其他'
  }
}

function get_from_outside_module() {
  const out_website_map = {
    'm.facebook.com': 'facebook',
    'www.facebook.com': 'facebook',
    'l.facebook.com': 'facebook',
    'lm.facebook.com': 'facebook',
    'www.google.com': 'google',
    'yeahpromos.com': 'yeahpromos',
    'l.instagram.com': 'instagram',
    'instagram.com': 'instagram',
    'com.google.android.gm': 'gmail',
    'conosur.net': 'conosur',
    'www.shareasale-analytics.com': 'shareasale-analytics',
    'shareasale-analytics.com': 'shareasale-analytics'
  }
  try {
    const urlObj = new window.URL(document.referrer)
    return out_website_map[urlObj.hostname]
  } catch (err) {
    return ''
  }
}

function get_from_info() {
  let from_page_code = getUrlParam('from_page') || ''
  let from_module_name = getUrlParam('from_module') || ''
  try {
    // 根据当前url中query获取from_page&from_module
    from_page_code = decodeURIComponent(atob(from_page_code))
    // from_module必须从外部传入
    from_module_name = decodeURIComponent(atob(from_module_name))
  } catch (err) {
    // do nothing,继续执行就好
  }

  const res = { from_page: from_page_code, from_module: from_module_name }
  if (from_page_code) {
    return res
  }
  // 没有传入from_page，走referrer
  res.from_page = sensor_f_get_pagecode(document.referrer)
  if (res.from_page === '站外') {
    res.from_module = document.referrer
  }
  return res
}

/* 获取页面ID */
function sensor_f_get_pageid() {
  var page_id = $("body").data("template");
  switch (page_id) {
    case "index":
      page_id = "首页";
      break;
    /* 集合ID */
    case "collection":
      page_id = $("#CollectionSection").data("collection-id").toString();
      break;
    /* 商品SPU */
    case "product":
      page_id = $("#shopify-section-product-template .product-section")
        .data("product-sku")
        .split(" ")[0];
      page_id = sensor_f_get_spu(page_id);
      break;
  }
  return page_id;
}

/* 获取spu */
function sensor_f_get_spu(page_id) {
  if (!page_id) {
    return ''
  }
  page_id = page_id.split(" ")[0];
  if (page_id.length > 15) {
    if (isNaN(page_id[12])) {
      page_id = page_id.substr(0, 12);
    } else if (isNaN(page_id[13])) {
      page_id = page_id.substr(0, 13);
    } else if (isNaN(page_id[14])) {
      page_id = page_id.substr(0, 14);
    } else if (isNaN(page_id[15])) {
      page_id = page_id.substr(0, 15);
    }
  }
  return page_id;
}

/* 获取模块位置 */
function sensor_f_get_module_num(id) {
  var result = 0; // more
  $("#MainContent .shopify-section").each(function (i, e) {
    if ($(e).attr("id") == id) {
      result = i + 1;
    }
  });
  return result;
}

/* 获取当前页面停留时长 */
var sensor_stay_start = new Date();

function sensor_f_get_stayTime(func) {
  $(window).bind("beforeunload", function () {
    var sensor_stay_end = new Date();
    var sensor_stay_time = Number(
      (
        (sensor_stay_end.getTime() - sensor_stay_start.getTime())
      ).toFixed(2)
    );
    func(sensor_stay_time);
  });
}

/* 获取支付页信息 */
function sensor_f_checkout_info(data) {
  data.product_quantity = 0;
  $(".product-thumbnail__quantity").each(function (i, e) {
    data.product_quantity += Number($(e).text().trim());
  });
  data.order_total = $('.total-recap__original-price').text().replace(/\D/g, "") / 100
  data.subtotal =
    typeof $(".total-line--subtotal .order-summary__emphasis") != "undefined" ?
      Number(
        (
          Number(
            $(".total-line--subtotal .order-summary__emphasis").data(
              "checkout-subtotal-price-target"
            )
          ) / 100.0
        ).toFixed(2)
      ) :
      0;

  data.coupon_discount =
    typeof $(".total-line--reduction .order-summary__emphasis") != "undefined" ?
      Number(
        (
          Number(
            $(".total-line--reduction .order-summary__emphasis").data(
              "checkout-discount-amount-target"
            )
          ) / 100.0
        ).toFixed(2)
      ) :
      0;

  data.shipping =
    typeof $(".total-line--shipping .order-summary__emphasis") != "undefined" ?
      Number(
        (
          Number(
            $(".total-line--shipping .order-summary__emphasis")
              .eq(0)
              .text()
              .replace(/\D/g, "")
          ) / 100.0
        ).toFixed(2)
      ) :
      0;
  data.total =
    typeof $(".payment-due__price").data("checkout-payment-due-target") !=
      "undefined" ?
      Number(
        (
          Number(
            $(".payment-due__price").data("checkout-payment-due-target")
          ) / 100.0
        ).toFixed(2)
      ) :
      0;
  data.shipping = isNaN(data.shipping) ? 0 : data.shipping;
  data.coupon_discount = isNaN(data.coupon_discount) ? 0 : data.coupon_discount;
  data.giftcard_discount = 0;
  $("span[data-checkout-applied-gift-card-amount-target]").each(function () {
    data.giftcard_discount += Number($(this).attr('data-checkout-applied-gift-card-amount-target') || 0)
  });
  data.giftcard_discount = Number((data.giftcard_discount / 100).toFixed(2));
  data.discount = data.coupon_discount + data.giftcard_discount;
  var product_spu_list = [], product_sku_list = []; product_quantity = 0;
  /** 用新的替换 */
  window.line_items.map(function (ele) {
    product_sku_list.push(ele.sku);
    product_spu_list.push(ele.sku.replace(/[A-Z][a-z]+.*$/, ""));
    product_quantity += parseInt(ele.quantity);
  })
  product_spu_list = [...new Set(product_spu_list)];
  data.product_spu_list = product_spu_list.join(",");
  data.product_sku_list = product_sku_list.join(",");
  data.product_quantity = product_quantity;
  // data = sensor_f_ajax_cart_sku_spu_list(data);
  return data;
}

/* 获取资源位名称 */
function sensor_f_get_module_name(e) {
  var name = $(e).find(".section-header__title").eq(0).text().trim();
  var name2 = $(e)
    .find(".section_title")
    .eq(0)
    .text()
    .replace("View More", "")
    .trim();
  name = name || name2;
  var id = $(e).attr("id");
  if (typeof id != "undefined") {
    id = id.replace("shopify-section-", "");
  } else if ($(e).attr("gallery-embed-id") == 179012) {
    id = 179012;
  }

  switch (id) {
    case "1524769873765":
      name = "顶部轮播Banner";
      break;
    case "1499789718857":
      name = "分类区";
      break;
    case "162467731003995de0":
      name = ["新品区", "热销区"];
      name = "";
      break;
    case "1624677601ffd7232b":
      name = ["WeddingGuest", "WeekendDating", "VacayVibes"];
      name = "";
      break;
    case "1620359124166dfb0b":
      name = "品牌介绍区";
      break;
    case "1620370553de9e8fbb":
      name = "评论区";
      break;
    case "179012":
      name = "ins区";
      break;
    case "16295406846eab3721":
      name = "分类区下-小海报";
      break;
    case "16305784924d912032":
      name = "折扣信息";
      break;
  }

  if ($(e).hasClass("index-section-sensor")) {
    var sensor_title = $(e).find("div").eq(0).data("sensor-title");
    if (typeof sensor_title != "undefined" && sensor_title != "") {
      name = sensor_title;
    }
  }

  if ($(e).hasClass("index-section-huey-collection")) {
    name = $(e).find(".collections-header-item.showing").eq(0).data("title");
  }

  return name;
}

/* 获取购物车sku-list */
function sensor_f_get_cart_sku_spu_list(data) {
  data.product_spu_list = [];
  data.product_sku_list = [];
  $("#CartDrawer .ajaxcart__row").each(function (i, e) {
    var sku = $(e).data("sku");
    var spu = sensor_f_get_spu(sku);
    data.product_sku_list.push(sku);
    if (data.product_sku_list.indexOf(spu) < 0) {
      data.product_spu_list.push(spu);
    }
  });
  data.product_sku_list = data.product_sku_list.toString().replace(/,/g, ";");
  data.product_spu_list = data.product_spu_list.toString().replace(/,/g, ";");
  return data;
}

/* 获取sku */
function sensor_f_get_sku(section) {
  var sku = section.find('.product-single__variants option:selected').data('sku') || ''
  return sku
}

/* ajax 获取购物车信息 */
var ajax_cart_data = [];
var ajax_cart_data_item_count = null;
var ajax_cart_data_item_finish_count = 0;

function sensor_f_ajax_cart_info(func) {
  var added_variants = [];
  $.getJSON("/cart.js", function (data, textStatus, jqXHR) {
    ajax_cart_data_item_count = data.items.length;
    ajax_cart_data_item_finish_count = 0;
    $(data.items).each(function (i, e) {
      $.getJSON("/products/" + e.handle, function (result, textStatus, jqXHR) {
        var product = result.product;
        $(product.variants).each(function (i, variant) {
          $(".product-table tr.product").each(function (i, tr_product) {
            if (
              variant.id == $(tr_product).data("variant-id") &&
              added_variants.indexOf(variant.id) < 0
            ) {
              added_variants.push(variant.id);
              var _data = {};
              _data.product_sku = variant.sku;
              _data.product_spu = sensor_f_get_spu(variant.sku);
              _data.product_name = product.title + "(" + variant.title + ")";
              _data.product_url =
                "/products/" + product.handle + "?variant=" + variant.id;
              _data.web_current_price = Number(variant.price);
              if (
                variant.compare_at_price == null ||
                variant.compare_at_price == 0
              ) {
                _data.web_original_price = _data.web_current_price;
              } else {
                _data.web_original_price = Number(variant.compare_at_price);
              }
              _data.web_discount_price = Number(
                (_data.web_original_price - _data.web_current_price).toFixed(2)
              );
              if (typeof func != "undefined") {
                func(_data);
              }
              ajax_cart_data.push(_data);
              ajax_cart_data_item_finish_count++;
              return false;
            }
          });
        });
      });
    });
  });
}

function sensor_f_ajax_cart_sku_spu_list(data) {
  if (ajax_cart_data.length > 0) {
    data.product_sku_list = [];
    data.product_spu_list = [];
    $(ajax_cart_data).each(function (i, e) {
      data.product_sku_list.push(e.product_sku);
      data.product_spu_list.push(e.product_spu);
    });
    data.product_sku_list = data.product_sku_list.toString().replace(/,/g, ";");
    data.product_spu_list = data.product_spu_list.toString().replace(/,/g, ";");
  }
  return data;
}

/* 导航栏展示 */
function sensor_navigationBarShow() {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  //console.log('NavigationBarShow', data);
  sensors.track("NavigationBarShow", data);
}

/* 点击导航栏具体类目 */
function sensor_navigationBarClick(e) {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.click_type = $(e).parents("ul").length;
  switch (data.click_type) {
    case 1:
      data.click_type = "一级菜单";
      data.firstlevel_name = $(e).text().trim();
      break;
    case 2:
      data.click_type = "二级菜单";
      data.secondlevel_name = $(e).text().trim();
      data.firstlevel_name = $(e)
        .parents(".mobile-nav__sublist.collapsible-content")
        .eq(0)
        .prev("div")
        .find("a.mobile-nav__link")
        .eq(0)
        .text()
        .trim();
      break;
    case 3:
      data.click_type = "三级菜单";
      data.thirdlevel_name = $(e).text().trim();
      data.secondlevel_name = $(e)
        .parents(".mobile-nav__sublist.collapsible-content")
        .eq(0)
        .prev("div")
        .find("a.mobile-nav__link")
        .eq(0)
        .text()
        .trim();
      data.firstlevel_name = $(e)
        .parents(".mobile-nav__sublist.collapsible-content")
        .eq(1)
        .prev("div")
        .find("a.mobile-nav__link")
        .eq(0)
        .text()
        .trim();
      break;
  }
  sensors.track("NavigationBarClick", data);
}

/* 点击BloomChic */
function sensor_bloomChicClick() {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  //console.log('BloomChicClick', data);
  sensors.track("BloomChicClick", data);
}

/* 点击搜索按钮 */
function sensor_searchButtonClick() {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  //console.log('SearchButtonClick', data);
  sensors.track("SearchButtonClick", data);
}

/* 快捷搜索 0 与搜索详情页的搜索按钮 1 */
function sensor_searchResult(type) {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.search_content = $('#go_search_input').val() || '';
  data.search_success = $('.section-header__title').attr('data-count') > 0;
  var product_id_list = [];
  var product_spu_list = [];
  if (data.search_success) {
    $('.search-grid-content .grid-product').each(function () {
      product_id_list.push($(this).data('product-id'))
      product_spu_list.push($(this).data('product-spu').replace(/[A-Z][a-z]+.*$/, ""))
    })
  }
  data.product_id_list = product_id_list.join(';');
  data.product_spu_list = product_spu_list.join(';')
  sensors.track("SearchResult", data)
}

/* 点击购物车按钮 */
function sensor_shoppingCartClick() {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  //console.log('ShoppingCartClick', data);
  sensors.track("ShoppingCartClick", data);
}

/* 上划页面 */
var sensor_haspost_pageSwipeUp = false;

function sensor_pageSwipeUp() {
  if (!sensor_haspost_pageSwipeUp) {
    sensor_haspost_pageSwipeUp = true;
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.page_id = sensor_f_get_pageid();
    //console.log('PageSwipeUp', data);
    sensors.track("PageSwipeUp", data);
  }
}

/* 首页展示 */
function sensor_frontPageShow() {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  //console.log('FrontPageShow', data);
  sensors.track("FrontPageShow", data);
}

/* 商品集合展示数据 */
function sensor_collectionPageData() {
  var data = {};
  data.collection_name = window.collections?.title || '';
  data.collection_id = String(window.collections?.id || '');
  data.collection_handle = window.collections?.handle || '';
  data.is_activitylabel =
    document.querySelectorAll(".grid-product__discount--text").length > 0;
  data.is_functiontag = document.querySelectorAll(".t_jiao").length > 0;
  return data;
}

/** 获取商品详情页面数据 */
function sensor_productPageData() {
  var product_section = $(".product-section").eq(0);
  var data = {};
  data.product_id = product_section.data("product-id");
  data.product_spu = sensor_f_get_pageid();
  data.product_from_page = getUrlParam("_sources_form") || localStorage.getItem("product_from_page");
  data.product_from_page === 'cart' && (data.product_from_page = '购物车')
  !data.product_from_page && (data.product_from_page = sensor_f_get_pagecode(document.referrer))
  data.product_name = product_section.data("product-title");
  data.is_available = product_section.data("product-vailable");
  data.sources_form = getUrlParam("_sources_form") || "";
  data.web_original_price = Number(
    (Number(product_section.data("product-orginal-price")) / 100.0).toFixed(2)
  );
  data.web_current_price = Number(
    (Number(product_section.data("product-price")) / 100.0).toFixed(2)
  );
  data.web_original_price =
    data.web_original_price == 0 ?
      data.web_current_price :
      data.web_original_price;
  data.web_discount_price = Number(
    (data.web_original_price - data.web_current_price).toFixed(2)
  );
  data.scm = getUrlParam('scm')
  data.transdata = theme.utils?.getUrlParam('transdata')
  data.is_productcoutdown = $(".product-countdown__box").length > 0;
  data.is_deliveryreminder = $(".blc_arriva_date").length > 0;
  data.preorder_skus = window.products.preorder_skus;
  var product_skc_tag = window.products.product_skc_tag || {};
  data.return_type = product_section.data('return-type');
  data.clearance_type = product_section.data('clearance-type');
  data.page_type = '商详页'
  data.module_name = '商详页'
  data.product_events_id = product_section.data('product-events-id') || 0;
  return Object.assign(data, product_skc_tag)
}

/* 商品详情页展示 */
function sensor_productPageShow() {
  var data = sensor_productPageData();
  data.module_name = sensor_f_get_pagecode();
  sensors.track("ProductPageShow", data);
}

/* 点击加入购物车 */
function sensor_addToCartClick() {
  var product_section = $(".product-section").eq(0);
  var data = {};
  data.product_from_page = sensor_f_get_pagecode(document.referrer);
  data.product_spu = sensor_f_get_pageid();
  data.product_sku = sensor_f_get_sku(product_section);
  data.product_name = product_section.data("product-title");
  data.product_id = String(product_section.data("product-id"));
  data.web_original_price = Number(
    (Number(product_section.data("product-orginal-price")) / 100.0).toFixed(2)
  );
  data.web_current_price = Number(
    (Number(product_section.data("product-price")) / 100.0).toFixed(2)
  );
  data.web_original_price =
    data.web_original_price == 0 ?
      data.web_current_price :
      data.web_original_price;
  data.web_discount_price = Number(
    (data.web_original_price - data.web_current_price).toFixed(2)
  );
  data.product_size = $("fieldset[name=Size] input[type=radio]:checked+label").text().trim();
  data.product_color = $("fieldset[name=Color] input[type=radio]:checked+label").text().trim();
  data.scm = getUrlParam("scm");
  data.transdata = getUrlParam("transdata");
  data.preorder_left_date = $('#product-preorder-time').attr('data-value') || 0;
  data.recommend_size = $('#product-rec-size').attr('data-value') || '';
  data.page_type = sensor_f_get_pagecode()
  data.module_name = sensor_f_get_pagecode()
  if (window.products.extendValue && data.product_sku) {
    const findOne = window.products.extendValue.variants.find(item => item.sku_code === data.sku)
    data.is_quickship = findOne?.is_quickship || false
  }
  sensors.track("AddToCartClick", data);
  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != "undefined") {
        window.location = url;
      }
    };
    gtag("event", "conversion", {
      send_to: "AW-444369709/6gDgCN7K2vABEK2W8tMB",
      value: 1.0,
      currency: "USD",
      event_callback: callback,
    });
    return false;
  }
  gtag_report_conversion();
}


/* 购物车展示 */
function sensor_cartShow(cart_type) {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.cart_type = cart_type;
  data.product_quantity = Number(
    $(".cart__checkout span").text().replace("(", "").replace(")", "")
  );
  data.subtotal = Number($("#itemCount").text().replace("$", ""));
  data = sensor_f_get_cart_sku_spu_list(data);
  //console.log("CartShow", data);
  sensors.track("CartShow", data);
}

/* 点击Check Out按钮 */
function sensor_checkOutClick(cart_type) {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.cart_type = cart_type;
  data.product_quantity = Number(
    $(".cart__checkout span").text().replace("(", "").replace(")", "")
  );
  data.subtotal = Number($("#itemCount").text().replace("$", ""));
  data = sensor_f_get_cart_sku_spu_list(data);
  //console.log('CheckOutClick', data);
  sensors.track("CheckOutClick", data);
  sensor_ProductCheckOutDetail(cart_type);
}

var ajax_cart_data2 = [];
var ajax_cart_datas_info = [];

function sensor_get_ajax_cart_data2() {
  ajax_cart_data2 = [];
  ajax_cart_datas_info = [];
  var added_variants = [];
  $.getJSON("/cart.js", function (data, textStatus, jqXHR) {
    ajax_cart_data2 = [];
    ajax_cart_datas_info = [];
    var added_variants = [];
    $(data.items).each(function (i, e) {
      $.getJSON("/products/" + e.handle, function (result, textStatus, jqXHR) {
        result.product.quantity = e.quantity;
        ajax_cart_datas_info.push(result.product);
        var product = result.product;
        $(product.variants).each(function (i, variant) {
          $("#CartContainer .ajaxcart__row").each(function (i, tr_product) {
            if (
              variant.sku == $(tr_product).data("sku") &&
              added_variants.indexOf(variant.id) < 0
            ) {
              added_variants.push(variant.id);
              var _data = {};
              _data.page_code = sensor_f_get_pagecode();
              _data.product_sku = variant.sku;
              _data.product_spu = sensor_f_get_spu(variant.sku);
              _data.product_name = product.title + "(" + variant.title + ")";
              _data.product_url =
                "/products/" + product.handle + "?variant=" + variant.id;
              _data.web_current_price = Number(variant.price);
              if (
                variant.compare_at_price == null ||
                variant.compare_at_price == 0
              ) {
                _data.web_original_price = _data.web_current_price;
              } else {
                _data.web_original_price = Number(variant.compare_at_price);
              }
              _data.web_discount_price = Number(
                (_data.web_original_price - _data.web_current_price).toFixed(2)
              );
              if (typeof func != "undefined") {
                func(_data);
              }
              ajax_cart_data2.push(_data);
              return false;
            }
          });
        });
      });
    });
  });
}

/* 商品进入结算 */
function sensor_ProductCheckOutDetail(cart_type) {
  $(ajax_cart_data2).each(function (i, data) {
    data.cart_type = cart_type;
    data.product_from_page = localStorage.getItem("atc-" + data.product_sku);
    //console.log("ProductCheckOutDetail",data);
    sensors.track("ProductCheckOutDetail", data);
  });
}

/* 结算页展示 */
function sensor_checkOutPageShow() {
  var data = {};
  data.page_name = $(".breadcrumb__item--current .breadcrumb__text")
    .text()
    .trim();
  data = sensor_f_checkout_info(data);
  if (data.page_name != "") {
    //console.log("CheckOutPageShow", data);
    sensors.track("CheckOutPageShow", data);
  }
}

// 补充父id
function sensor_productExtend(data, e) {
  data.parent_product_id = window.products ? window.products.id : '' // 补充父id
  var section = $(e).parents("div[data-section-collectin-id]");
  var collection_id = "";
  if (section && section.length) {
    collection_id = section.data('section-collectin-id') || ''
  }
  data.collection_id = collection_id ? collection_id : (window.collections ? window.collections.id : '') // 补充collection_id
  data.collection_handle = section.data('section-collection-handle')
  data.search_content = $('#go_search_input').val() || ''; //搜索内容
  return data
}

/** 注册商品曝光事件 */
function sensor_productShowNew(el) {
  clearTimeout(el.elementTimer)
  el.elementTimer = setTimeout(() => {
    if (el.elementVisabled) {
      sensor_productItemShow(el)
    }
  }, 500)
}

/** 新的商品曝光*/
function sensor_productItemShow(el) {
  var data = sensor_f_get_product_item_data(el)
  data.product_id && sensors.trackRepeat("ProductShow", data);
  // data.product_id && sensors.track("ProductShow", data);
}

/** 新的商品点击事件 */
function sensor_productItemClickNew(e) {
  sensors.track("ProductClick", sensor_f_get_product_item_data(e));
}


/** 新的获取商品item数据 */
function sensor_f_get_product_item_data(e) {
  var data = {};
  var section = $(e).parents(".shopify-section").eq(0);
  data.module_name = section.find('div[data-section-name]').attr('data-section-name') || '';
  data.page_code = sensor_f_get_pagecode();
  data.web_module_number = $(e).data("product-index"); // 从-开始
  data.product_id = String($(e).data("product-id"));
  data.product_spu = sensor_f_get_spu($(e).data("product-spu"));
  data.product_name = $(e).data("product-title") || $(e).find(".grid-product__title").eq(0).text();
  data.is_available = $(e).data("product-vailable");
  data.web_original_price = Number((Number($(e).data("product-orginal-price")) / 100.0).toFixed(2));
  data.web_current_price = Number((Number($(e).data("product-price")) / 100.0).toFixed(2));
  data.web_original_price =
    data.web_original_price == 0 ?
      data.web_current_price :
      data.web_original_price;
  data.web_discount_price = Number(
    (data.web_original_price - data.web_current_price).toFixed(2)
  );
  data.collection_id = $(e).data("collection-id");// 补充collection_id
  data.collection_handle = $(e).data("collection-handle");
  var product_url = $(e).find("a").eq(0).attr("href");
  data.product_url = product_url && product_url.includes('http') ? product_url : location.origin + product_url;
  data.product_handle = $(e).data("product-handle");
  data.media_url = getImgUrl(e);
  data.clearance_type = $(e).data('clearance-type');
  data.product_events_id = $(e).data('product-events-id') || 0;
  data.is_quickship = $(e).data('is_quickship') || false;
  return data;
}

/**
 * 获取资源位数据
 * @param el 
 * @returns 
 */
function sensor_f_get_resource_data(el) {
  var data = {};
  var child_dom = $(el).hasClass('shopify-section-item') ? $(el) : ''; // 子元素
  var parent = $(el).parents('.shopify-section');
  if (!parent || !parent.length) {
    parent = $(el);
  }
  data.web_resource_id = parent.attr('id').replace('shopify-section-', '') || '';
  var currect_section = parent.find(`[data-section-id="${data.web_resource_id}"]`).eq(0);
  if (!currect_section.length || !data.web_resource_id) {
    return
  }
  var child_index = child_dom ? child_dom.attr('data-index') || 0 : 0; // 子模块从1开始，默认为0
  data.page_code = sensor_f_get_pagecode();
  data.web_module_number = Number(sensor_f_get_module_num(parent.attr('id')) + (child_index ? '.' + child_index : ''));
  data.model_index = data.web_module_number
  data.section_name = currect_section.attr('data-section-name');
  data.module_name = data.section_name || sensor_f_get_module_name(parent);
  data.section_type = currect_section.attr('section-type') || '';
  data.module_type = child_dom ? 'item' : 'module';
  data.skip_page_url = child_dom ? child_dom.attr('href') || child_dom.find('a').attr('href') : parent.find('a').eq(0).attr('href');
  data.skip_page_url = data.skip_page_url || '';
  if (data.skip_page_url && !data.skip_page_url.includes('http')) {
    data.skip_page_url = window.location.origin + data.skip_page_url;
  }

  data.media_url = child_dom ? getImgUrl(child_dom) : '';
  if (data.media_url && !data.media_url.includes('http')) {
    data.media_url = window.location.protocol + data.media_url;
  }
  var current_el = child_dom || parent;
  data.ad_pos_percent = Number((current_el.width() * current_el.height()) / (window.screen.width * window.screen.height)); // 屏占比
  if (!data.module_name) {
    data.module_name = data.web_resource_id; // 兜底处理
  }
  // 3.9
  var title_box = child_dom ? parent : currect_section;
  data.title = title_box.find('.section-title').text() || '';
  data.name = currect_section.attr('data-name') || '';
  data.type = currect_section.attr('data-type') || '';
  return data
}
/**
 * 新的资源位展示
 * @param el 
 */
function sensor_resourceShowNew(el) {
  clearTimeout(el.elementTimer)
  el.elementTimer = setTimeout(() => {
    if (el.elementVisabled) {
      var data = sensor_f_get_resource_data(el);
      sensors.trackRepeat('ResourceShow', data);
    }
  }, 500)
}
/**
 * 新的资源位点击
 * @param el 
 */
function sensor_resourceClickNew(el) {
  var data = sensor_f_get_resource_data(el);
  sensors.track('ResourceClick', data);
}

/* 资源位点击 */
function sensor_resourceClick(e) {
  var section = $(e).parents(".shopify-section")[0];
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.module_name = sensor_f_get_module_name(section);
  data.web_resource_id = $(section).attr("id").replace("shopify-section-", "");
  data.web_module_number = sensor_f_get_module_num($(section).attr("id"));
  var click_index = $(e).attr("data-index") || "";
  if (click_index) {
    click_index = "." + click_index;
  }
  data.web_module_number += click_index;
  data.skip_page_url = $(e).attr("href");
  data.section_name = $(section).find(`[data-section-id=${data.web_resource_id}]`).eq(0).attr("data-section-name")
  if (data.module_name == "" || data.module_name == "顶部轮播Banner") {
    switch (data.web_resource_id) {
      case "162467731003995de0":
        $("#shopify-section-162467731003995de0 .custom__item a").each(function (
          i,
          _e
        ) {
          if (_e == e) {
            data.module_name = i == 0 ? "新品区" : "热销区";
            data.web_module_number = Number(
              (data.web_module_number + (i + 1) / 10.0).toFixed(2)
            );
          }
        });
        break;
      case "1624677601ffd7232b":
        $("#shopify-section-1624677601ffd7232b .grid__item a").each(function (
          i,
          _e
        ) {
          if (_e == e) {
            data.web_module_number = Number(
              (data.web_module_number + (i + 1) / 10.0).toFixed(2)
            );
            switch (i) {
              case 0:
                data.module_name = "WeddingGuest";
                break;
              case 1:
                data.module_name = "WeekendDating";
                break;
              case 2:
                data.module_name = "VacayVibes";
                break;
            }
          }
        });
        break;
      // case "1524769873765":
      //   var sub_index = $(e).parents(".slideshow__slide").eq(0).data("index");
      //   data.web_module_number = Number(
      //     (data.web_module_number + (sub_index + 1) / 10.0).toFixed(2)
      //   );
      //   break;
    }
  }
  // console.log("ResourceClick", data);
  sensors.track("ResourceClick", data);
}

/* 离开首页 */
function sensor_frontPageLeave(stayTime) {
  var data = {};
  data.stay_time = stayTime;
  //console.log('FrontPageLeave', data);
  sensors.track("FrontPageLeave", data);
}

/* 使用某个排序 */
function sensor_sortMethodClick() {
  var data = {};
  data.collection_id = sensor_f_get_pageid();
  data.collection_name = document.title;
  data.sort_method = $("#SortBy option:selected").text().trim();

  //console.log('SortMethodClick', data);
  sensors.track("SortMethodClick", data);
}

/* 点击翻页 */
function sensor_collectionTurnPage(turn_page_type) {
  var data = {};
  data.collection_id = sensor_f_get_pageid();
  data.collection_name = document.title;
  data.turn_page_type = turn_page_type;

  //console.log('CollectionTurnPage', data);
  sensors.track("CollectionTurnPage", data);
}

/* 离开商品集合 */
function sensor_collectionLeave(stayTime) {
  var data = {};
  data.collection_id = sensor_f_get_pageid();
  data.collection_name = document.title;
  data.product_number = $(".grid-product.sensor-posted").length;
  data.stay_time = stayTime;

  //console.log('CollectionLeave', data);
  sensors.track("CollectionLeave", data);
}

/* 点击查看大图 */
var sensor_e_bigPicture_hasPost = false;

function sensor_bigPictureClick() {
  if (!sensor_e_bigPicture_hasPost) {
    sensor_e_bigPicture_hasPost = true;
    var product_section = $(".product-section").eq(0);
    var data = {};
    data.product_spu = sensor_f_get_pageid();
    data.product_name = product_section.data("product-title");

    //console.log('BigPictureClick', data);
    sensors.track("BigPictureClick", data);
  }
}

/* 离开商品详情页 */
function sensor_productPageLeave(stayTime) {
  var product_section = $(".product-section").eq(0);
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.product_spu = sensor_f_get_pageid();
  data.product_name = product_section.data("product-title");
  data.is_available = product_section.data("product-vailable");
  data.stay_time = stayTime;

  //console.log('ProductPageLeave', data);
  sensors.track("ProductPageLeave", data);
}

/* 点击Add按钮 */
function sensor_addButtonClick(cart_type) {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.cart_type = cart_type;
  data.product_quantity = Number(
    $(".cart__checkout span").text().replace("(", "").replace(")", "")
  );
  data.subtotal = Number($("#itemCount").text().replace("$", ""));
  //console.log('AddButtonClick', data);
  console.log("data-->", data);
  sensors.track("AddButtonClick", data);
}

/**
 * 获取已选中的支付方式
 */
function sensor_f_getSelectedPaymentName() {
  var payment_name = $('.section--payment-method').find('.input-radio:checked').parent().next().find('label').text();
  payment_name = payment_name ? payment_name.replace(/(^\s*)|(\s*$)|[\r\n]/g, "") : ""
  return payment_name
}

/* 支付按钮展示 */
function sensor_payButtonShow(e) {
  var data = {};
  data = sensor_f_checkout_info(data);
  var btn = $("#continue_button span").eq(0).text().trim();

  var payButton = "";
  switch (btn) {
    case "Continue to shipping":
      payButton = "ContinueShippingShow";
      break;
    case "Continue to payment":
      payButton = "ContinueToPaymentShow";
      var ship_fee = Number(
        (
          $(".section--shipping-method .input-radio:checked")
            .eq(0)
            .data("checkout-total-shipping-cents") / 100.0
        ).toFixed(2)
      );
      data.shipping = ship_fee;
      data.total = Number(
        (data.subtotal + data.shipping - data.discount).toFixed(2)
      );
      break;
    case "Pay now":
      payButton = "PayNowButtonShow";
      data.button_type = 1;
      data.direct_payment_name = sensor_f_getSelectedPaymentName();
      break;
    case "Complete order":
      payButton = "PayNowButtonShow";
      data.button_type = 2;
      data.direct_payment_name = sensor_f_getSelectedPaymentName();
  }
  if (payButton != "") {
    //console.log(payButton, data);
    sensors.track(payButton, data);
  }
}

/* 支付按钮点击 */
function sensor_payButtonClick(payButton, shipping_fee = -1) {
  var data = {};
  data = sensor_f_checkout_info(data);
  if (shipping_fee != -1) {
    data.shipping = shipping_fee;
    data.total = Number(
      (data.subtotal + data.shipping - data.discount).toFixed(2)
    );
  }
  //console.log(payButton, data);
  if (payButton == "ContinueShippingClick") {
    data.first_name = $('input[data-backup="first_name"]').val();
    data.last_name = $('input[data-backup="last_name"]').val();
    data.address = $('input[data-backup="address1"]').val();
    data.apartment = $('input[data-backup="address2"]').val();
    data.subscribe = $('#checkout_buyer_accepts_marketing').prop('checked')
  }

  if (payButton == "PayNowButtonClick") {
    var btn = $("#continue_button span").eq(0).text().trim();
    data.button_type = btn == "Pay now" ? 1 : 2;

    data.shopify_payment_method = data.button_type;
    data.direct_payment_name = sensor_f_getSelectedPaymentName();
    const label = $('input[name="checkout[payment_gateway]"]:checked')
      .parents(".radio-wrapper")
      .find("label");
    if (label && label.text().indexOf("Klarna") >= 0) {
      data.shopify_payment_method = 3;
    }
  }
  //console.log(payButton, data);
  sensors.track(payButton, data);
}

/* 商品进入支付 */
function sensor_productPayNowDetail() {
  $(ajax_cart_data).each(function (i, e) {
    //console.log("ProductPayNowDetail", e);
    sensors.track("ProductPayNowDetail", e);
  });
}

/* 订单支付成功展示 */
function sensor_paymentSuccessShow() {
  var data = {};
  data = sensor_f_checkout_info(data);
  data.order = window.order_number || "";
  data.page_type = Shopify.Checkout.step === "thank_you" ? "thank_you" : "checkout_detail";
  sensors.track("PaymentSuccessShow", data);
}

/* 点击Order summary */
function sensor_orderSummaryClick() {
  var data = {};
  data.page_name = $(".breadcrumb__item--current .breadcrumb__text").text();
  data.click_type = $(".order-summary-toggle").hasClass(
    "order-summary-toggle--show"
  ) ?
    1 :
    2;
  data = sensor_f_checkout_info(data);
  sensors.track("OrderSummaryClick", data);
}

/* 点击Back to Click */
function sensor_backtoClick(event) {
  var data = {};
  data = sensor_f_checkout_info(data);
  sensors.track(event, data);
}
/** 这个会用新的 sensor_getQuickPaymentName 替换 */
function sensor_f_getExpressPaymentMethod(current) {
  var payname = $(current).find("div[data-testid]").attr("data-testid") || "";
  if (payname) {
    payname = ["shopifypay", "googlepay", "applepay"].find(function (item) {
      return payname.toLowerCase().includes(item.toLowerCase());
    });
  } else {
    payname = "paypel";
  }
  var result = 0;
  if ($(current).find("iframe")) {
    result = 2;
  } else {
    payname = $(current).find("div[data-testid]").attr("data-testid");
  }
  switch (payname) {
    case "shoppay":
      result = 1;
      break;
    case "googlepay":
      result = 4;
      break;
    case "applepay":
      result = 3;
  }
  return result;
}

/** 快捷支付方式名 */
function sensor_f_getQuickPaymentName(current) {
  var payment_name = $(current).find("span").eq(0).text() || "PayPal";
  return payment_name.replace(/^\s+|\s+$/g, "");
}
/** 获取快捷展示的Info for show/click */
function sensor_f_getExpressCheckoutInfo(current) {
  var data = {};
  data.express_payment_method = sensor_f_getExpressPaymentMethod(current);
  data.quick_payment_name = sensor_f_getQuickPaymentName(current);
  data = sensor_f_checkout_info(data);
  return data;
}

/* 快捷支付方式展示 已调整 */
function sensor_expressCheckOutShow(current) {
  var data = sensor_f_getExpressCheckoutInfo(current);
  sensors.track("ExpressCheckOutShow", data);
}

/* 点击快捷支付方式 已调整 */
function sensor_expressCheckOutClick(current) {
  var data = sensor_f_getExpressCheckoutInfo(current);
  sensors.track("ExpressCheckOutClick", data);
}

/* 点击进度条 */
function sensor_progressBarClick(bar) {
  var data = {};
  data.page_name = $(".breadcrumb__item--current .breadcrumb__text")
    .text()
    .trim();
  data.to_page_name = $(bar).find(".progressBarItemTitle").text().trim();
  data = sensor_f_checkout_info(data);
  sensors.track("ProgressBarClick", data);
}

/* 应用优惠或礼品卡 */
function sensor_couponApplied(code, position) {
  var data = {};
  data.page_name = $(".breadcrumb__item--current .breadcrumb__text")
    .text()
    .trim();
  data.coupon_code = code;
  data.position = position;
  sensors.track("CouponApplied", data);
}

function validTrackTimeInterval(id, interval) {
  const ts = new Date().getTime();
  try {
    const t = localStorage.getItem(id);
    if (t && Number(t) + interval * 1000 - ts > 0) {
      return false;
    }
    localStorage.setItem(id, ts);
    return true;
  } catch (e) {
    localStorage.setItem(id, ts);
    return true;
  }
}

function sensor_quickViewClick() {
  if (!validTrackTimeInterval("_qvcts", 2 * 60 * 60)) return;
  sensors.track("QuickViewClick", {
    quickview_click: "1",
  });
}

function sensor_quickViewShow() {
  if (!validTrackTimeInterval("_qvsts", 2 * 60 * 60)) return;
  sensors.track("QuickViewShow", {
    quickview_show: "1",
  });
}

var sensor_klarna = {
  timer: null,
  interval: 0,
  time: 10,
  checkshow() {
    sensor_klarna.timer = setInterval(() => {
      var elm = document.querySelector("klarna-placement");
      sensor_klarna.interval += 1;
      if (elm) {
        $(elm).parent().on("click", sensor_klarna.trackClick);
        sensors.track("KlarnaInstallmentShow");
        console.log("Klarna show");
        clearInterval(sensor_klarna.timer);
      }

      if (sensor_klarna.interval > sensor_klarna.time) {
        clearInterval(sensor_klarna.timer);
      }
    }, 1000);
  },
  trackClick() {
    sensors.track("KlarnaLearnMoreClick");
  },
};

function sensor_f_couponAppliedBind() {
  var page_name = $(".breadcrumb__item--current .breadcrumb__text")
    .text()
    .trim();
  var couponBind = setInterval(() => {
    if (!$("#checkout_reduction_code").hasClass("bind")) {
      clearInterval(couponBind);
      var btn = $("#checkout_reduction_code")
        .parents("form")
        .eq(0)
        .find('button[type="submit"]')
        .eq(0);
      btn.click(function () {
        var code = $("#checkout_reduction_code").val();
        sensor_couponApplied(code, 1);
        sensor_f_couponAppliedBind();
      });
      $(".tags-list").click(function () {
        sensor_f_couponAppliedBind();
      });
      $("#checkout_reduction_code").addClass("bind");
      if (page_name == "Payment") {
        btn = $("#checkout_reduction_code_mobile")
          .parents("form")
          .eq(0)
          .find('button[type="submit"]')
          .eq(0);
        btn.click(function () {
          var code = $("#checkout_reduction_code_mobile").val();
          sensor_couponApplied(code, 2);
          sensor_f_couponAppliedBind();
        });
        $("#checkout_reduction_code_mobile").addClass("bind");
      }
    }
  }, 100);
}

/* 商品详情页点击下拉模特 */
function sensor_productModelSizeClick() {
  var product_section = $(".product-section").eq(0);
  var data = {};
  data.product_spu = sensor_f_get_pageid();
  data.product_from_page = localStorage.getItem("product_from_page");
  data.product_name = product_section.data("product-title");
  sensors.track("ProductModelSizeClick", data);
}

/* 点击下拉模特选择的选项 */
function sensor_productModelSizeSelected() {
  var product_section = $(".product-section").eq(0);
  var model_size_el = $(".select-model-size .placeholder");
  var data = {};
  data.product_spu = sensor_f_get_pageid();
  data.product_from_page = localStorage.getItem("product_from_page");
  data.product_name = product_section.data("product-title");
  data.model_id = model_size_el.attr("data-value");
  data.model_size = model_size_el.html();
  sensors.track("ProductModelSizeSelected", data);
}
/** 用户结算页面的登陆 */
function sensor_checkoutLoginClick() {
  var data = sensor_f_checkout_info({});
  sensors.track("CheckoutLogInClick", data)
}
/** 用户结算页面退出 */
function sensor_checkoutLogOutClick() {
  var data = {};
  data.email = email;
  data = sensor_f_checkout_info(data);
  sensors.track("CheckoutLogOutClick", data);
}

/** 结算成功 */
function sensor_paymentComplete() {
  var data = {};
  // var payment_name = [];
  // $(".payment-method-list").find(".payment-icon span").each(function () {
  //   payment_name.push($(this).text().replace(/(^\s*)|(\s*$)|[\r\n]/g, ""))
  // });
  data = sensor_f_checkout_info(data);
  data.order = window.order_number || "";
  // data.payment_type = window.sessionStorage.getItem("paymentTypeForCheckout") || "quick_pay"; // ? "direct_pay" : "quick_pay";
  // data.payment_name = payment_name.join(",");
  // data.is_shoppay = $('body').html().indexOf('shop.app/pay') > -1;
  sensors.track("PaymentComplete", data);
  // window.sessionStorage.removeItem("paymentTypeForCheckout"); // 清空
}

/** 新方法，用于注册checkout埋点事件 */
function initSensorCheckoutEvents() {
  /** 结算退出 */
  // $(".logged-in-customer-information__paragraph a").click(function() {
  //   sensor_checkoutLogOutClick();
  // });
  /** 结算登录 */
  // $(".layout-flex__item a").click(function() {
  //   sensor_checkoutLoginClick();
  // })
  /** 结算 */
  if (Shopify && Shopify.Checkout) {
    if (Shopify.Checkout.step === "shipping_method" || Shopify.Checkout.step == "payment_method") {
      // var hasPayments = $('.section--payment-method');
      window.sessionStorage.setItem("paymentTypeForCheckout", "direct_pay");
    }
    if (Shopify.Checkout.step === "contact_information") {
      window.sessionStorage.setItem("paymentTypeForCheckout", "quick_pay");
    }
    if (Shopify.Checkout.step === "thank_you") {
      sensor_paymentComplete()
      // if (window.pptag) {
      //   window.pptag.send("purchase");
      //   window.pptag.send("store_cash_exclusion");
      // }
    }
  }
}

function sensor_SMSsubscribe(check_result, phone, email) {
  var data = {};
  data.page_code = sensor_f_get_pagecode();
  data.check_result = check_result;
  data.email_content = email;
  data.sms_content = phone;
  sensors.track("SMSsubscribe", data);
}

/* 登录弹窗展示 */
function sensor_loginShow() {
  sensors.track("SignInPageShow", {
    page_from: sensor_f_get_pagecode(document.referrer || '')
  });
}
/* 登录按钮点击 */
function sensor_loginClick(data) {
  sensors.track("SignInClick", data);
}

/* 登录结果上报 */
function sensor_loginResult(data) {
  sensors.track("SignInClickResult", data);
}

/* 注册弹窗展示 */
function sensor_registerShow() {
  sensors.track("RegisterPageShow", {
    page_from: sensor_f_get_pagecode(document.referrer || '')
  });
}

/* 注册弹窗展示 */
function sensor_registerClick(data) {
  sensors.track("RegisterClick", data);
}

/* 注册结果上报 */
function sensor_registerResult(data) {
  sensors.track("RegisterClickResult", data);
}
/** 重置密码申请 */
function sensor_passwordResetSubmitted() {
  sensors.track('PasswordResetSubmittedClick')
}

/** 重置密码上报 */
function sensor_passwordReset() {
  sensors.track('PasswordResetClick')
}
/** 重置密码结果 */
function sensor_passwordResetResult(data) {
  sensors.track('PasswordResetResult', data)
}

var gobal_scroll_data;

/***          事件绑定           ***/
$(function () {
  /* 滑动页面 */
  var scroll_data = new Array();

  /* 支付页事件 */
  // if (location.pathname.indexOf("orders") > 0) {
  //   initSensorCheckoutEvents();
  // }
  if (location.pathname.indexOf("checkouts") > 0) {
    initSensorCheckoutEvents();
    /* 结算页展示 */
    // initSensorCheckoutEvents(); // 做新的方法入口,暂时不开放
    $(".breadcrumb__item--current").children;
    sensor_f_ajax_cart_info();
    $(".review-block__link").on("click", function (e) {
      // var page = ''
      // const match = window.location.search.match(new RegExp(/step=.+&?/g))
      // if (match && match[0]) {
      //   if (match[0].indexOf('shipping') >= 0) page = 'Shipping'
      //   if (match[0].indexOf('payment') >= 0) page = 'Payment'
      // }

      sensors.track("ChangeButtonClick", {
        page_name: $(".breadcrumb__item--current")
          .children(".breadcrumb__text")
          .html(),
        change_context: $(e.currentTarget).parent(".review-block").index() + 1,
      });
    });
    // var loadcart_interval = setInterval(() => {
    // if (
    // ajax_cart_data_item_count != null &&
    // ajax_cart_data_item_finish_count == ajax_cart_data_item_count &&
    // bloomchic_sensor.abtest_funcs != "undefined" &&
    // bloomchic_sensor.abtest_funcs.payment0927 != "undefined"
    // ) {
    console.log("bind-sensor!", sensors);
    // clearInterval(loadcart_interval);
    sensor_checkOutPageShow();
    var page_name = $(".breadcrumb__item--current .breadcrumb__text").text().trim();
    page_name = page_name || $('.breadcrumb__item.breadcrumb__item--current').text().trim(); // 对原来的补充 

    scroll_data.push({
      className: "#continue_button",
      func: sensor_payButtonShow,
    });

    if (page_name == "Information") {
      scroll_data.push({
        className: "li[data-testid]",
        func: sensor_expressCheckOutShow,
      });
    }

    $(window).scroll(function () {
      /* 页面上滑 */
      sensor_pageSwipeUp();
      sensor_f_getClassTag(scroll_data);
    });
    sensor_f_getClassTag(scroll_data, false);
    $(document).on('click', "#continue_button", function () {
      switch (page_name) {
        case "Information":
          sensor_payButtonClick("ContinueShippingClick");
          break;
        case "Shipping":
          var ship_fee = Number(
            (
              $(".section--shipping-method .input-radio:checked")
                .eq(0)
                .data("checkout-total-shipping-cents") / 100.0
            ).toFixed(2)
          );
          sensor_payButtonClick("ContinueToPaymentClick", ship_fee);
          break;
        case "Payment":
          sensor_payButtonClick("PayNowButtonClick");
          sensor_productPayNowDetail();
          break;
      }
    });

    $(".step__footer__previous-link").click(function () {
      switch (page_name) {
        case "Information":
          sensor_payButtonClick("ReturnToCartClick");
          break;
        case "Shipping":
          var ship_fee = Number(
            (
              $(".section--shipping-method .input-radio:checked")
                .eq(0)
                .data("checkout-total-shipping-cents") / 100.0
            ).toFixed(2)
          );
          sensor_payButtonClick("ReturnToInformationClick", ship_fee);
          break;
        case "Payment":
          sensor_payButtonClick("ReturnToShippingClick");
          break;
      }
    });

    $("button.order-summary-toggle").click(function () {
      sensor_orderSummaryClick();
    });

    $(".headBack a").click(function () {
      var event = "";
      switch (page_name) {
        case "Information":
          event = "BackToCartClick";
          break;
        case "Shipping":
          event = "BackToInformationClick";
          break;
        case "Payment":
          event = "BackToShippingClick";
          break;
      }
      if (event != "") {
        sensor_backtoClick(event);
      }
    });

    if (page_name == "Information") {
      $(document).on("click", "li[data-testid]", function () {
        sensor_expressCheckOutClick(this);
      });
      // 没办法，只能在这里监听message来处理PayPal Pay
      window.addEventListener('message', function (e) {
        if (e && e.data && typeof e.data == 'string' && e.data != 'undefined' && e.origin.includes('paypal')) {
          var datas = JSON.parse(e.data);
          var __postRobot__ = datas.__postRobot__;
          if (__postRobot__ && __postRobot__.data && __postRobot__.data.name == 'onClick') {
            // 确认已经点击
            var data = {};
            data.express_payment_method = 2;
            data.quick_payment_name = "PayPal";
            data = sensor_f_checkout_info(data);
            sensors.track("ExpressCheckOutClick", data);
          }
        }
      });
    }
    var findProgressBarInterval = setInterval(() => {
      if ($(".progressBar a").length > 0) {
        clearInterval(findProgressBarInterval);
        $(".progressBar a").click(function () {
          sensor_progressBarClick(this);
        });
      }
    }, 100);
    sensor_f_couponAppliedBind();
    // }
    // }, 100);
    /** 新的商品点击事件 */
  } else {
    sensor_klarna.checkshow();

    $(document).on("click", ".blc-product-mars", function (evt) {
      sensor_productClickNew(evt);
      event.preventDefault();
      return false;
    })
    sensor_get_ajax_cart_data2();
    /* 非支付页 */
    /* 导航栏展示 */
    $(".js-drawer-open-nav").click(function () {
      sensor_navigationBarShow();
      sensors.track("ReferBannerShow", {
        page_code: "1",
      });
    });

    $(".referral_btn").on("click", function () {
      sensors.track("ReferBannerClick", {
        page_code: "1",
      });
    });
    // $(".referral_banner_btn").on('click', function() {
    //   sensors.track('ReferBannerClick')
    // })

    document
      .querySelectorAll(".section-refferral-banner")
      .forEach(function (i) {
        scroll_data.push({
          className: i,
          func: function () {
            sensors.track("ReferBannerShow", {
              page_code: $(i).data("section-from"),
            });
          },
        });
      });
    document.querySelectorAll(".ql__item").forEach(function (i) {
      scroll_data.push({
        className: i,
        func: function () {
          sensors.track("NavigatinTabShow", {
            collection_id: $(i).data("collection-id"),
            collection_name: $(i).data("collection-name"),
          });
        },
      });
      $(i).on("click", function () {
        sensors.track("NavigatinTabClick", {
          collection_id: $(this).data("collection-id"),
          collection_name: $(this).data("collection-name"),
        });
      });
    });
    // console.log('trustpilot_main-->start', $('.trustpilot_main'))
    /** 第三方Trustpilot 弃用 */
    // document.querySelectorAll(".trustpilot_main").forEach(function (i) {
    //   scroll_data.push({
    //     className: i,
    //     func: function () {
    //       sensors.track("TrustPilotShow", {
    //         page_code: $(i).attr("data-type") == "1" ? "1" : "2",
    //       });
    //     },
    //   });
    // });

    /* 点击导航栏具体类目 */
    // $(".mobile-nav__link").click(function () {
    //   if (!$(this).hasClass("currency")) {
    //     sensor_navigationBarClick(this);
    //   }
    // });
    /* PC点击导航栏具体类目 */
    $(".site-navigation a").click(function () {
      var data = {};
      data.page_code = sensor_f_get_pagecode();
      data.click_level = parseInt($(this).data("level"));
      data.click_type = ["一", "二", "三"][data.click_level - 1] + "级菜单";
      data.click_url = $(this).href;
      data.is_image_click = $(this).data("isimg");
      data.firstlevel_name = $(this).data("first");
      data.secondlevel_name = $(this).data("second");
      data.thirdlevel_name = $(this).data("third");
      data.is_go = true;
      sensors.track("NavigationBarClick", data);
    })

    /* 点击BloomChic */
    $(".header-item--logo").click(function () {
      sensor_bloomChicClick();
    });

    /* 点击搜索按钮 */
    $(".site-nav__icons .js-search-header *").click(function () {
      sensor_searchButtonClick();
    });

    /* 点击购物车按钮 */
    $(".js-drawer-open-cart .cart-link").click(function () {
      sensor_shoppingCartClick();
      //sensor_cartShow("侧边栏展开购物车");
    });

    /** QuickView点击 弃用 */
    // $(".quick-product__btn").mouseenter(function () {
    //   sensor_quickViewShow();
    // });
    /** 未知埋点 弃用 */
    // $("#shopify-section-product-recommendations").mousemove(function (e) {
    //   if (e.target.classList.contains("quick-product__btn")) {
    //     sensor_quickViewShow();
    //   }
    // });

    /** Size Guide click track 弃用 */
    // $(".seeMore2").click(function () {
    //   sensors.track("SizeGuideClick");
    // });

    /* 商品展示 */
    // scroll_data.push({
    //   className: ".grid__item.grid-product",
    //   func: sensor_productShow,
    // });
    /** 通过曝光与点击通过data-属性上报 */
    function sensorClickExposure(el, type) {
      if (el) {
        // console.log('el===', el.nodeType, el.nodeName)
        const data = { ...el.dataset };
        const event = type == 'click' ? data.sensorsClick : data.sensorsExposure;
        if (!event) {
          return
        }
        if (el.nodeName == 'IMG') {
          const ad_pos_percent = el.offsetHeight * el.offsetWidth / (window.screen.width * window.screen.height);
          data.media_url = data.media_url || el.getAttribute('data-src') || el.getAttribute('src');
          data.ad_pos_percent = ad_pos_percent;
        }
        delete data.sensorsClick;
        delete data.sensorsExposure;
        sensors.track(event, data);
      }
    }

    /* 商品展示或者资源位展示 */
    const ob = new IntersectionObserver(function (oblist) {
      for (var i = 0; i < oblist.length; i++) {
        var currentOb = oblist[i]
        const el = currentOb.target
        el.elementVisabled = currentOb.isIntersecting
        if (el.classList.contains('shopify-section') || el.classList.contains('shopify-section-item')) {
          // 大资源位埋点
          sensor_resourceShowNew(el)
        } else {
          sensor_productShowNew(el)
        }
        if (el && el.dataset.hasOwnProperty('sensorsExposure')) {
          sensorClickExposure(el, 'exposure')
        }
      }
    }, {})

    document.querySelectorAll('.grid__item.grid-product, .product-grid-item, #MainContent .shopify-section, #MainContent .shopify-section-item, [data-sensors-exposure]').forEach((e) => {
      ob.observe(e)
    });

    document.querySelectorAll('[data-sensors-click]').forEach(function (el) {
      el.addEventListener('click', function () {
        sensorClickExposure(el, 'click');
      })
    })
    /**
     * 商品点击
     */
    $('.product-grid-item').click(function () {
      sensor_productItemClickNew($(this))
    })
    /**
     * 资源位点击
     */
    $('.shopify-section-item, #MainContent .shopify-section a:not(.shopify-section-item)').click(function () {
      sensor_resourceClickNew(this);
    });

    /** 资源位展示 */


    var page_code = $("body").data("template");
    /** 旧的资源位，弃用 */

    // if (page_code == "index") {
    //   scroll_data.push({
    //     className: "#MainContent .shopify-section",
    //     func: sensor_resourceShow,
    //   });
    //   scroll_data.push({
    //     className: "#shopify-section-162467731003995de0 .custom__item",
    //     func: sensor_resourceShow2,
    //   });
    //   scroll_data.push({
    //     className: "#shopify-section-1624677601ffd7232b .grid__item",
    //     func: sensor_resourceShow3,
    //   });
    // }
    gobal_scroll_data = [...scroll_data];

    // console.log("gobal_scroll_data", gobal_scroll_data);
    $(window).scroll(function () {
      /* 页面上滑 */
      sensor_pageSwipeUp();
      sensor_f_getClassTag(scroll_data);
    });
    sensor_f_getClassTag(scroll_data, false);

    /* 商品点击 */
    $(document).on("click", ".grid__item.grid-product a", function (evt) {
      sensor_productClick(this);
    })

    /**/
    switch (page_code) {
      case "index":
        /* 首页展示 */
        sensor_frontPageShow();
        /* 离开首页 */
        sensor_f_get_stayTime(sensor_frontPageLeave);
        /** 未找到模块 弃用 */
        // $(
        //   "#shopify-section-1620370553de9e8fbb .jdgm-carousel__arrows div"
        // ).click(function () {
        //   sensor_resourceClick(this);
        // });
        break;
      case "collection":
        /* 商品集合展示 */
        // sensor_collectionShow();
        /* 离开集合页 */
        sensor_f_get_stayTime(sensor_collectionLeave);
        /* 搜索点击 弃用 */
        // $("#SortBy").change(function () {
        //   sensor_sortMethodClick();
        // });

        /* 点击翻页 弃用 */
        // $(".pagination a").click(function () {
        //   sensor_collectionTurnPage(2);
        // });

        break;
      case "product":
        /* 商品详情页展示 */
        sensor_productPageShow();
        $(".add-to-cart").click(function () {
          sensor_addToCartClick();
          //sensor_cartShow("侧边栏展开购物车");
        });

        /* 点击查看大图 */
        $(".flickity-viewport img").click(function () {
          sensor_bigPictureClick();
        });

        /* 离开商品详情页 */
        sensor_f_get_stayTime(sensor_productPageLeave);
        break;
    }
  }
  /* thank you 页 */
  // if (location.pathname.split("/")[4] == "thank_you") {
  //   sensor_paymentSuccessShow();
  // }
  if (
    Shopify &&
    Shopify.Checkout &&
    (Shopify.Checkout.isOrderStatusPage ||
      Shopify.Checkout.step === "thank_you")
  ) {
    sensor_paymentSuccessShow();
  }
});

/* 转盘上报 */
var bloomchic_sensor = {};
bloomchic_sensor.lottery = {
  get_lottery_popup_type() {
    var result = 1;
    if (lottery.data.is_lottery) {
      switch (lottery.data.ab_type) {
        case "A":
          result = 2;
          break;
        case "B":
          result = 3;
          break;
        case "C":
          result = 4;
          break;
      }
      switch (lottery.data.abc_test_type) {
        case "B":
          result = 5;
          break;
        case "C":
          result = 6;
          break;
        case "D":
          result = 7;
          break;
      }
      return result;
    }
  },

  get_lottery_spin_result() {
    var result = -1;
    switch (lottery.data.abtest0924) {
      case "A":
        result = lottery.data.result == 20 ? 2 : 1;
        break;
      case "B":
        result = lottery.data.result == 20 ? 4 : 3;
        break;
      case "C":
        result = lottery.data.result == 20 ? 6 : 5;
        break;
    }
    return result;
  },

  get_lottery_is_lottery() {
    return lottery.data.prize_code != "" ? 1 : 2;
  },

  get_lottery_popup_source() {
    return lottery.data.popup_source;
  },

  SpinPopupShow() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    sensors.track("SpinPopupShow", data);
  },

  EmailInput(email_check_result, email) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.email_check_result = email_check_result;
    data.email_content = email;
    //sensors.track('EmailInput', data);
  },

  PhoneInput(phone_check_result) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.phone_check_result = phone_check_result;
    sensors.track("PhoneInput", data);
  },

  StarSpinTheWheel(click_item, check_result, email, phone) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.click_item = click_item;
    data.check_result = check_result;
    data.email_content = email;
    sensors.track("StarSpinTheWheel", data);
  },

  StarSpinTheWheelSMS(click_item, check_result, email, phone) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.click_item = click_item;
    data.check_result = check_result;
    data.email_content = email;
    data.sms_content = phone;
    sensors.track("StarSpinTheWheelSMS", data);
  },

  RulesClick(click_item) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.click_item = click_item;
    sensors.track("RulesClick", data);
  },

  CloseButtonClick(step_type = 1) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.step_type = step_type
    sensors.track("CloseButtonClick", data);
  },

  CloseConfirmClick(click_item) {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.click_item = click_item;
    data.popup_source = this.get_lottery_popup_source();
    sensors.track("CloseConfirmClick", data);
  },

  SpinResultShow() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.spin_result = this.get_lottery_spin_result();
    data.has_sms = lottery.data.has_sms;
    sensors.track("SpinResultShow", data);
  },

  ContinueShoppingClick() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    sensors.track("ContinueShoppingClick", data);
  },

  SpinEntryShow() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.spin_entry_type = this.get_lottery_is_lottery();
    sensors.track("SpinEntryShow", data);
  },

  SpinEntryClick() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.spin_entry_type = this.get_lottery_is_lottery();
    sensors.track("SpinEntryClick", data);
  },

  SpinEntryCloseClick() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    sensors.track("SpinEntryCloseClick", data);
  },

  CouponPopupShow() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    sensors.track("CouponPopupShow", data);
  },

  CouponPopupButtonClick() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    sensors.track("CouponPopupButtonClick", data);
  },

  CouponPopupCloseClick() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    sensors.track("CouponPopupCloseClick", data);
  },

  CloseConfirmShow() {
    var data = {};
    data.page_code = sensor_f_get_pagecode();
    data.popup_type = this.get_lottery_popup_type();
    data.popup_source = this.get_lottery_popup_source();
    sensors.track("CloseConfirmShow", data);
  },
};

bloomchic_sensor.abtest = null;
bloomchic_sensor.abtest_funcs = {};
bloomchic_sensor.abtests = [];

/* product view事件 */
bloomchic_sensor.productView = {
  getLspv: function () {
    var lspv = localStorage.getItem("lspv");
    if (lspv != null) {
      lspv = JSON.parse(lspv);
      if (lspv.t + 1000 * 60 * 60 * 2 < new Date().getTime()) {
        localStorage.removeItem("lspv");
        lspv = null;
      } else if (lspv.c.length >= 10000) {
        localStorage.removeItem("lspv");
        lspv = null;
      }
    }
    if (lspv == null) {
      lspv = {};
      lspv.t = new Date().getTime();
      lspv.c = [];
    }
    return lspv;
  },

  addVisited: function (vcp) {
    var lspv = this.getLspv();
    lspv.c.push(vcp);
    localStorage.setItem("lspv", JSON.stringify(lspv));
  },

  checkVisited: function (vcp) {
    var result = false;
    var lspv = this.getLspv();
    if (lspv.c.includes(vcp)) {
      result = true;
    }
    return result;
  },
};

bloomchic_sensor.productView.getLspv();





